import { NgClass } from '@angular/common';
import { Component, Input, OnChanges, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgOptionComponent, NgSelectComponent } from '@ng-select/ng-select';

import { TooltipDirective } from '@shared/directives/tooltip.directive';
import { CurveType } from '@shared/services/gql.service';
import { Option } from '@shared/types/components.type';

import {
  ForecastTableGridMethodChange,
  ForecastTableGridSiteCurveInterface,
} from '../../models/forecast-table-grid.model';

@Component({
  imports: [NgSelectComponent, TooltipDirective, NgClass, FormsModule, NgOptionComponent],
  selector: 'aux-forecast-table-grid-period-site',
  styleUrls: ['./forecast-table-grid-period-site.component.scss'],
  templateUrl: './forecast-table-grid-period-site.component.html',
})
export class ForecastTableGridPeriodSiteComponent implements OnChanges {
  @Input() categoryId = '';
  @Input() disabled = false;
  @Input() driverSettingId = '';
  @ViewChild('gridPeriodSite') public input!: NgSelectComponent;
  @Input() isChild = false;
  @Input() isInvalid = false;
  @Input() onMethodChange!: ForecastTableGridMethodChange;
  @Input() periodSiteOptions: Option<CurveType>[] = [];
  @Input() placeholder = '';
  @Input() primarySettingsId = '';
  selectedPeriodSiteOption = '';
  @Input() siteCurves: ForecastTableGridSiteCurveInterface[] = [];
  @Input() tooltip = '';

  ngOnChanges(): void {
    this.initSitePeriod();
  }

  initSitePeriod(): void {
    if (!this.driverSettingId) {
      this.setSitePeriod(CurveType.NET);

      return;
    }

    const siteCurve = this.siteCurves.find((curve) => {
      return curve.value === this.driverSettingId;
    });

    this.setSitePeriod(siteCurve?.curveType || CurveType.NET);
  }

  onModelChange(event: string): void {
    const siteCurveByDriver = this.siteCurves.find((curve) => {
      return curve.value === this.driverSettingId;
    })?.label;

    const siteCurve = this.siteCurves.find((curve) => {
      return curve.curveType === event && curve.label === siteCurveByDriver;
    });

    if (siteCurve?.value) {
      this.onMethodChange(siteCurve.value, this.primarySettingsId, {
        id: this.categoryId,
        name: !this.isChild ? 'category' : 'activity',
        prop: 'driver_setting',
      });
    }
  }

  setSitePeriod(curveType: CurveType): void {
    this.selectedPeriodSiteOption = curveType;
  }
}
